import  {useRef, useState, useEffect} from "react";
import {
  Row,
  Col,
  Overlay,
  OverlayTrigger,
  Tooltip,
  Button,
  ButtonGroup,
  Popover
} from "react-bootstrap";
import CallGroupStats from "components/CallGroupDetails/CallGroupStats";
import ResetListState from "components/ResetListState";
import { MdRefresh, MdInfo } from "react-icons/md";
import "./DisplayBar.css";
import "assets/css/components.css";
import { Form } from "react-bootstrap";
import { isLoggedInUserBioSimilarUser } from "services/AWUtilityService";


const DisplayBar = ({
  dataTestId,
  tableTitle,
  totalRecords,
  refreshIcon = false,
  refresh,
  toggleBioSimilarBool,
  isCallGroupListScreen,
  handleBioSimilarToggle,
  reset,
  externalLinks,
  onInfoHover,
}) => {
  const [show, setShow] = useState(false);
  const hideTimeoutRef = useRef(null);
  const infoHoverTimeoutRef = useRef(null);
  const target = useRef(null);

   useEffect(() => {
    return () => {
      clearTimeout(hideTimeoutRef.current);
      clearTimeout(infoHoverTimeoutRef.current);
    };
  }, []);

  const handleMouseEnter = () => {
     clearTimeout(hideTimeoutRef.current);
    infoHoverTimeoutRef.current = setTimeout(() => {
      onInfoHover();
    }, 300); 
    setShow(true);
  };

  const handleMouseLeave = () => {
    clearTimeout(infoHoverTimeoutRef.current); // Cancel the pending info hover call
    hideTimeoutRef.current = setTimeout(() => {
      setShow(false);
    }, 300); 
  };

  const renderPopover = (
    <Popover 
       id="call-info-popover"
      className="popover-max-310"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <Popover.Body>
        <CallGroupStats />
      </Popover.Body>
    </Popover>
  );
  return (
    <div className="display-bar">
      <Row>
        <Col md={12}>
          <Row className="codex-version-display-bar">
            <Col md={4} className="my-auto">
              <span style={{ float: "left" }}>
                {" "}
                Total {externalLinks ? "" : tableTitle}:{" "}
                <strong id="callgroup-total-count" data-testid={dataTestId}>
                  {!isCallGroupListScreen && totalRecords}
                  {isCallGroupListScreen &&  (
                    <>
                    <span
            ref={target}
            className="icon-hover-trigger"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: 'pointer' }}
          >
            <MdInfo color="#dcdcdc" size={22} />
          </span>

          <Overlay
            show={show}
            target={target.current}
            placement="right"
            containerPadding={10}
          >
                  {renderPopover}
                </Overlay>
                </>
                )}
                </strong>
              </span>
            </Col>
            <Col md={4} className="my-auto">
              <span>
                <strong style={{ float: "center" }}>{tableTitle}</strong>
              </span>
            </Col>
            {isCallGroupListScreen && isLoggedInUserBioSimilarUser() && (
              <Col md={3} className="my-auto">
                <span className="tiny-bottom-spacer">
                  <OverlayTrigger
                    overlay={
                      <Tooltip>
                        Toggling this ON will show Bio Similar Groups
                      </Tooltip>
                    }
                  >
                    <Form.Check
                      type="switch"
                      className="aw-bio-similar-callgroups-toggle"
                      id="toggleBioSimilarRef"
                      label={`Bio Similar Call Groups`}
                      onChange={(e) => handleBioSimilarToggle(e)}
                      checked={toggleBioSimilarBool}
                    />
                  </OverlayTrigger>
                </span>
              </Col>
            )}
            {refreshIcon ? (
              <Col md={3} className="my-auto">
                <OverlayTrigger
                  overlay={<Tooltip>Refresh Page and Activity List</Tooltip>}
                >
                  <div className="aw-refresh-link">
                    <MdRefresh
                      onClick={() => {
                        refresh();
                      }}
                    />
                    <span
                      style={{ fontSize: "0.50em" }}
                      data-testid="btn-refresh-page"
                    >
                      Refresh Page
                    </span>
                  </div>
                </OverlayTrigger>
              </Col>
            ) : null}
            {reset ? (
              <Col
                md={
                  isLoggedInUserBioSimilarUser()
                    ? 1
                    : isCallGroupListScreen
                    ? 4
                    : 1
                }
                className="my-auto"
              >
                <span className="tiny-bottom-spacer">
                  <ResetListState
                    onReset={() => reset()}
                    // resetterDisabled={
                    //   JSON.stringify(listState.filtered) === JSON.stringify(defaultFilters) &&
                    //     JSON.stringify(listState.sorted) === JSON.stringify(defaultSorts)
                    // }
                  />
                </span>
              </Col>
            ) : null}
            {externalLinks ? (
              <Col md={4}>
                <ButtonGroup
                  className="pull-right"
                  aria-label="External Links Group"
                >
                  {externalLinks.map((link, idx) => {
                    return (
                      <Button
                        key={link.url}
                        href={link.url}
                        target="_blank"
                        variant="light"
                      >
                        {link.title}
                      </Button>
                    );
                  })}
                </ButtonGroup>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>
    </div>
  );
};
export default DisplayBar;
